module.exports = __webpack_public_path__ + "img/bookshelf01.83b9d42b.jpg";